module.exports = __webpack_public_path__ + "img/id.1455cd23.svg";